
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    // Enhanced logging for 404 errors
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
    
    // Special logging for potential vanity URL issues
    if (location.pathname.startsWith('/t/') || location.pathname.startsWith('/poll/')) {
      const pathParts = location.pathname.split('/').filter(Boolean);
      console.error("404 on potential vanity URL:", {
        pathParts,
        partsCount: pathParts.length,
        fullPath: location.pathname,
        isShortFormat: location.pathname.startsWith('/t/'),
        possibleSlug: pathParts[1]
      });
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center p-8 bg-white rounded-lg shadow-md">
        <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-2">Oops! Page not found</p>
        <p className="text-gray-500 mb-6">The page you're looking for doesn't exist or may have been moved.</p>
        <Button asChild variant="default" size="lg">
          <a href="/">Return to Home</a>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
